const reviews = [
  {
    name: "Sgt. Travis B.",
    location: "Malmstrom AFB, Great Falls, MT",
    rating: 5,
    text: "Being stationed at Malmstrom, I travel internationally frequently and always need a valid passport. Fast Passport Center handled my renewal quickly and professionally — exactly what I needed before deployment leave.",
    service: "Military Expedited",
  },
  {
    name: "Nancy F.",
    location: "Great Falls, MT",
    rating: 5,
    text: "My daughter forgot to renew before a graduation trip to Mexico. I called Fast Passport Center on a Tuesday, shipped docs that night, and she had her passport by Monday. Absolute lifesavers for Great Falls families.",
    service: "Emergency Renewal",
  },
  {
    name: "Dan W.",
    location: "Fort Benton, MT",
    rating: 5,
    text: "The drive to Denver alone would have cost more than this service. Fast Passport Center mailed my passport to my door in 7 days. Best decision I made — highly recommend for anyone in central Montana.",
    service: "Standard Expedited",
  },
];

export default function TestimonialsSection() {
  return (
    <section id="reviews" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Great Falls Travelers Are Saying
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base">
            Real customers. Real results. No Denver agency trip required.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {reviews.map((r, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-7 flex flex-col">
              <div className="flex items-center gap-0.5 mb-4">
                {Array.from({ length: r.rating }).map((_, j) => (
                  <i key={j} className="ri-star-fill text-[#F6C344] text-sm"></i>
                ))}
              </div>
              <p className="text-gray-600 text-sm leading-relaxed mb-6 flex-1">&ldquo;{r.text}&rdquo;</p>
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{r.name}</p>
                  <p className="text-gray-400 text-xs">{r.location}</p>
                </div>
                <span className="bg-[#EEF2F8] text-[#1A365D] text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                  {r.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}